import { combineReducers } from 'redux';

import { accessGroupReducer } from '../access-groups/store/reducer';
import { adminAnalyticsReducer } from '../analytics/store/reducer';
import { adminAttestationReducer } from '../attestations/store/reducer';
import { calculatorReducer } from '../calculator/store/reducer';
import { clientCalculatorReducer } from '../client-calculator/store/reducer';
import { clientDatasetsReducer } from '../client-datasets/store/reducer';
import { clientRiskToleranceReducer } from '../client-risk-tolerance/store/reducer';
import { clientReducer } from '../clients/store/reducer';
import { datasetBuilderReducer } from '../dataset-builder/store/reducer';
import { documentNameReducer } from '../documents/store/reducer';
import { dropdownListReducer } from '../dropdown-lists/store/reducer';
import { entityReducer } from '../entity/store/reducer';
import { sendNotificationReducer } from '../notification/store/reducer';
import { adminOpinionReducer } from '../opinions/store/reducer';
import { adminPlaybookReducer } from '../playbook/store/reducer';
import { portfolioAnalyticsReducer } from '../portfolio-analytics/store/reducer';
import { riskToleranceReducer } from '../risk-tolerance/store/reducer';
import { rolesReducer } from '../roles/store/reducer';
import { subCounterpartyReducer } from '../sub-counterparty-types/store/reducer';
import { usersReducer } from '../users/store/reducer';
import { workflowReducer } from '../workflow/store/reducer';
import { systemMaintenanceReducer } from '../system-maintenance/store/reducer';
import { adminAIReducer } from '../ai/store/reducer';

export const adminReducer = combineReducers({
    ai: adminAIReducer,
    accessGroups: accessGroupReducer,
    attestations: adminAttestationReducer,
    analytics: adminAnalyticsReducer,
    dataset: datasetBuilderReducer,
    documents: documentNameReducer,
    dropdownList: dropdownListReducer,
    clientDatasets: clientDatasetsReducer,
    clientRiskTolerance: clientRiskToleranceReducer,
    clientCalculator: clientCalculatorReducer,
    entity: entityReducer,
    users: usersReducer,
    clients: clientReducer,
    workflow: workflowReducer,
    opinions: adminOpinionReducer,
    playbook: adminPlaybookReducer,
    sendNotification: sendNotificationReducer,
    riskTolerance: riskToleranceReducer,
    subCounterparty: subCounterpartyReducer,
    calculator: calculatorReducer,
    portfolioAnalytics: portfolioAnalyticsReducer,
    roles: rolesReducer,
    systemMaintenance: systemMaintenanceReducer
});
